import React from "react";
import { useGetBlogsPostsQuery } from "src/redux/api";
import { BlogCard } from "src/page-components/blog/BlogCard";
import { NextButton } from "src/page-components/blog/NextButton";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { Loader } from "src/components/Loader";
import { Sizes } from "src/@types/sizes";
import { getImageUrl } from "src/constants/urls";
import { SEO } from "src/components/SEO/SEO";
import { PATHNAMES } from "src/constants/routes";

const Blog = () => {
  const { data: blogsList, isLoading, isError } = useGetBlogsPostsQuery();

  if (isLoading) return <Loader size={Sizes.L} />;

  if (isError || !blogsList) {
    return (
      <>
        <SEO
          title="Блог"
          description="Статті та новини про бухгалтерський облік, оподаткування та юридичний супровід бізнесу"
          url={PATHNAMES.BLOG}
        />
        <PageWrapper mainClassName="bg-gray-light">
        <section className="pb-6 container">
          <div className="flex flex-col gap-5 lg:gap-8 p-5 lg:p-10 2xl:py-15 2xl:px-31 bg-white-base rounded-2xl">
            <h2 className="text-28 sm:text-4xl lg:text-5xl 2xl:text-64 text-green-dark">
              Блог
            </h2>
            <p className="text-green-dark">Помилка завантаження даних</p>
          </div>
        </section>
      </PageWrapper>
      </>
    );
  }

  return (
    <>
      <SEO
        title="Блог"
        description="Статті та новини про бухгалтерський облік, оподаткування та юридичний супровід бізнесу"
        url={PATHNAMES.BLOG}
      />
      <PageWrapper mainClassName="bg-gray-light">
      <section className="pb-6 container">
        <div className="flex flex-col gap-5 lg:gap-8 p-5 lg:p-10 2xl:py-15 2xl:px-31 bg-white-base rounded-2xl">
          <h2 className="text-28 sm:text-4xl lg:text-5xl 2xl:text-64 text-green-dark">
            Блог
          </h2>

          {blogsList.length === 0 ? (
            <p className="text-green-dark">Немає доступних статей</p>
          ) : (
            <ul className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3 lg:gap-5">
              {blogsList.map((item) => (
                <li key={item.id} className="relative">
                  <BlogCard
                    {...item}
                    background_image={item.background_image ? getImageUrl(item.background_image) : undefined}
                  />
                  <NextButton id={item.id} theme={item.theme} />
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
    </PageWrapper>
    </>
  );
};

export default Blog;
